import { BehaviorSubject, map } from 'rxjs';

export abstract class BaseStoreService<T> {
  data$ = new BehaviorSubject<Record<string, T>>({});

  getDataObservable(key: string) {
    return this.data$.pipe(
      map(items => {
        return Object.keys(items).length ? items[key] : undefined;
      }),
    );
  }

  getData(key: string) {
    return Object.keys(this.data$.value).length ? this.data$.value[key] : undefined;
  }

  setData(key: string, data: T) {
    const storeItems = this.data$.value;
    storeItems[key] = data;
    this.data$.next(storeItems);
  }
}
